const initNrp = (root = document) => {
  root.querySelectorAll('[data-nrp-gallery]').forEach((gallery) => {
    if (gallery.dataset.nrpGalleryReady === 'true') return;
    gallery.dataset.nrpGalleryReady = 'true';
    const main = gallery.querySelector('.nrp__main-image img');
    const modal = gallery.closest('.nrp').querySelector('[data-nrp-modal]');
    const thumbs = [...gallery.querySelectorAll('[data-nrp-thumb]')];
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    const showImage = (index) => {
      if (!thumbs.length || !main) return;
      activeIndex = (index + thumbs.length) % thumbs.length;
      thumbs.forEach((item, itemIndex) => {
        const active = itemIndex === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
      const thumb = thumbs[activeIndex];
      main.src = thumb.dataset.full;
      main.removeAttribute('srcset');
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    gallery.querySelector('[data-nrp-gallery-prev]')?.addEventListener('click', (event) => { event.stopPropagation(); showImage(activeIndex - 1); });
    gallery.querySelector('[data-nrp-gallery-next]')?.addEventListener('click', (event) => { event.stopPropagation(); showImage(activeIndex + 1); });
    gallery.querySelector('[data-nrp-open-image]')?.addEventListener('click', () => {
      if (!modal || !main) return;
      modal.querySelector('img').src = main.currentSrc || main.src;
      modal.showModal();
    });
    modal?.querySelector('[data-nrp-close]')?.addEventListener('click', () => modal.close());
    modal?.addEventListener('click', (event) => { if (event.target === modal) modal.close(); });
  });
  document.querySelectorAll('[data-nrp-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.nrp__main-image img');
    const modal = gallery.closest('.nrp').querySelector('[data-nrp-modal]');
    gallery.querySelectorAll('[data-nrp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('[data-nrp-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (main) main.src = thumb.dataset.full;
      });
    });
    gallery.querySelector('[data-nrp-open-image]')?.addEventListener('click', () => {
      if (!modal || !main) return;
      modal.querySelector('img').src = main.currentSrc || main.src;
      modal.showModal();
    });
    modal?.querySelector('[data-nrp-close]')?.addEventListener('click', () => modal.close());
    modal?.addEventListener('click', (event) => { if (event.target === modal) modal.close(); });
  });
  document.querySelectorAll('[data-nrp-mobile-add]').forEach((button) => {
    button.addEventListener('click', () => document.querySelector('#nrp-product-form button[name="add"]')?.click());
  });

  document.querySelectorAll('[data-nrp-product]').forEach((product) => {
    const form = product.querySelector('#nrp-product-form');
    const basePrice = Number(product.dataset.nrpBasePrice || 0);
    const variantId = Number(product.dataset.nrpVariantId || 0);
    const total = product.querySelector('[data-nrp-total]');
    const money = (pence) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'GBP'
    }).format(pence / 100);
    const setBusy = (busy) => {
      product.querySelectorAll('[data-nrp-upsell-choice], #nrp-product-form button[name="add"], [data-nrp-open-upsell]').forEach((control) => {
        control.disabled = busy;
      });
    };
    const addSelection = async (ids = []) => {
      if (!variantId) return;
      setBusy(true);
      try {
        const items = [{ id: variantId, quantity: 1 }, ...ids.filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }))];
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('One of the selected items is no longer available.');
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (error) {
        setBusy(false);
        window.alert(error.message || 'We could not add these items. Please try again.');
      }
    };

    const bundleInputs = product.querySelectorAll('[data-nrp-bundles] input[name="nrp_bundle"]');
    bundleInputs.forEach((input) => {
      input.addEventListener('change', () => {
        product.querySelectorAll('.nrp__bundle').forEach((bundle) => bundle.classList.remove('is-selected'));
        input.closest('.nrp__bundle')?.classList.add('is-selected');
        if (total) total.textContent = money(basePrice + Number(input.dataset.extraPrice || 0));
      });
    });

    form?.addEventListener('submit', (event) => {
      const selected = product.querySelector('[data-nrp-bundles] input[name="nrp_bundle"]:checked');
      const ids = (selected?.dataset.extraIds || '').split(',').filter(Boolean);
      if (!ids.length) return;
      event.preventDefault();
      addSelection(ids);
    });

    const upsellModal = product.querySelector('[data-nrp-upsell-modal]');
    product.querySelector('[data-nrp-open-upsell]')?.addEventListener('click', () => upsellModal?.showModal());
    product.querySelector('[data-nrp-upsell-close]')?.addEventListener('click', () => upsellModal?.close());
    upsellModal?.addEventListener('click', (event) => { if (event.target === upsellModal) upsellModal.close(); });
    product.querySelectorAll('[data-nrp-upsell-choice]').forEach((choice) => {
      choice.addEventListener('click', () => addSelection((choice.dataset.extraIds || '').split(',').filter(Boolean)));
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initNrp());
} else {
  initNrp();
}
document.addEventListener('shopify:section:load', (event) => initNrp(event.target));
